// document.addEventListener('crPickupActivated', function (e) {
//     console.log('____ activated _____')
//     if (jqCR('.pickup-button').hasClass('selected') && !jqCR('[data-cart-item-title="Pickup - in store"]').length){
//       setTimeout(function(){
//       	location.reload();    	
//       }, 500)	
      
//     }    
// });
var CRcarrierServiceEnabled = true;
// **** Better way to set special products in one place **** ////
var pickup = false;
var noPickup = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Available for Pickup'.toLowerCase()) > -1) {
    pickup = true;
  } else {
    noPickup = true;
  }
}

document.addEventListener('crJQActivated', function (e) {
  setTimeout(function(){
    if (noPickup === true) {
      jqCR('.pickup-wrapper').remove()
    }
  }, 200)  
})

